module.exports = __webpack_public_path__ + "ded03e8154f9f31cb45fc356142ecc79.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-post-header/icon-design.png
// module id = ./src/components/blog-post-header/icon-design.png
// module chunks = index